import { RS_REGION_URLS } from "../constants";

export function getStreamingQuality() {
    let qualityLevel = 2; // Default high quality
    const connectionObj = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connectionObj) {
        const { effectiveType, downlink } = connectionObj;
        if (effectiveType) {
            switch (effectiveType) {
                case "slow-2g":
                case "2g":
                    qualityLevel = 0;
                    break;
                case "3g":
                    qualityLevel = 1;
                    break;
                case "4g":
                case "5g":
                default:
                    qualityLevel = 2;
            }
        } else if (downlink) {
            if (downlink < 1) {
                qualityLevel = 0;
            } else if (downlink < 5) {
                qualityLevel = 1;
            } else {
                qualityLevel = 2;
            }
        }
    } else {
        qualityLevel = 1;
    }
    return qualityLevel;
}

export async function determineNearestRegion() {
    try {
        const results = await Promise.all(
            RS_REGION_URLS.map(async ({ name, url }) => {
                const start = performance.now();
                try {
                    await fetch(url, { method: "GET", cache: "no-store", mode: "no-cors" });
                } catch (err) {
                    console.error(`Error fetching ${name}:`, err);
                }
                const latency = performance.now() - start;
                return { region: name, latency };
            })
        );

        results.sort((a, b) => a.latency - b.latency);
        const fastest = results[0];
        console.log(`Fastest region: ${fastest.region} (${fastest.latency.toFixed(2)}ms)`);
        return fastest.region;
    } catch (error) {
        console.error("Error determining nearest region:", error);
        console.log("Falling back to default region: us-east-1");
        return "us-east-1";
    }
}

export async function isSessionValidAndActive(url, token) {
    try {
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error("Session is not valid or active");
        const result = await response.json();
        console.log("Session status:", result.data?.status);
        if (result.data?.status !== "occupied") return false;
        return true;
    } catch (error) {
        console.error("Error checking session status:", error);
        return false;
    }
}
